import script from "./CityPageView.vue?vue&type=script&setup=true&lang=js"
export * from "./CityPageView.vue?vue&type=script&setup=true&lang=js"

import "./CityPageView.vue?vue&type=style&index=0&id=920b71b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-920b71b4"]])

export default __exports__